var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKolltukuBardh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8982",
    "data-name": "Path 8982",
    d: "M17.364,8.571A1.548,1.548,0,0,0,15.727,10v2.143H4.273V10A1.548,1.548,0,0,0,2.636,8.571,1.548,1.548,0,0,0,1,10v3.571A1.548,1.548,0,0,0,2.636,15H17.364A1.548,1.548,0,0,0,19,13.571V10A1.548,1.548,0,0,0,17.364,8.571ZM14.909,5H5.091A1.548,1.548,0,0,0,3.455,6.429V7.964A2.179,2.179,0,0,1,5.091,9.979v1.45h9.818V9.979a2.192,2.192,0,0,1,1.636-2.014V6.429A1.548,1.548,0,0,0,14.909,5Z",
    transform: "translate(-1 -5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKolltukuBardh);
export default __webpack_public_path__ + "static/media/kolltuku_bardh.aec4573448597c599bceb5b002ee61a1.svg";
export { ForwardRef as ReactComponent };